import useStore from './_store';
import { mapState as rootMapState, mapActions as rootMapActions } from 'pinia';
import { mapState, mapActions } from '@/store/helpers';
import { useUserStore, usePageStore } from '@/store';

import formula from '../../components/caculator/lib/calFormula.js';
import ThreeDTour from '../../components/threed-tour/index.js';
import util from '../../common/util.js';
import { getPreNextUrl } from '../../common/search-request';

import signlog from '../../components/sign-log';
import Caculator from '../../components/caculator/index.js';
import popMgr from '@/components/global/popMgr';
import SharePop from './share-pop.vue';
import { colorBlock } from '../defaultSpacing';
import onAutoPopup from '@/common/autopopup';
import { getListingDetailSchemaInfo } from '@/common/schemaInfo.js';
import MediaPop from './media-pop.vue';
import GalleryPop from './gallery-pop.vue';
import MediaPopLayout from './media-pop-layout.vue';
import GalleryPopLayout from './gallery-pop-layout.vue';
import { mapAsyncData } from '../../plugins/asyncData';
import { asyncData, getAgent } from './asyncData';
import { isUrls } from "@/router/index.js"
import spaceMixin from '@/modules/space-mixin';
import colorMixin from '@/modules/color-mixin';
import { calcColorRootVar } from '@/init/data/handlerData.js';
import { getShowSoldPrice } from '@/common/house';
import { getOfficeStatus, getTemplate, PROVIDED_POSITION_KEY } from '@/common/mls';

export default {
    _getUseStore: useStore,
    i18next: {
        ns: ['common', 'md-detail-info']
        // translationResourcesLoaded() {
        //     this.getInfoFlag();
        // }
    },
    mixins: [colorMixin(), spaceMixin()],
    asyncData: mapAsyncData(asyncData),
    data: function() {
        let config = {
            payment: {
                downPaymentRatio: 20,
                propertyTaxRate: 0,
                loanTerm: 30,
                interestRate: 4,
                homeInsurance: 0,
                hoaFee: 0,
                chimeMaintenanceFee: 0
            },
            agentId: 0, // show on schedule under agent information
            originPriority: true, // First show the listing's real agent
            showCoAgent: false, // whether to show cooperation agent
            showMakeOffer: true, // use or not make offer message   There are only three sets
            daysOnSite: 10, // Decide detail-info display of
            triggerCalculator: false,
            triggerReadMore: false,
            readMoreExpanded: false, // Whether to expand by default readmore
            showVirtualTour: true,
            makeOfferTitle: '', //make an offer title
            makeOfferButtonText: '', //make an offer submit button text
            scheduleNameFormat: '', //schedule a tour  form name format 'full'/'separate'
            schedulePhoneRequired: false, //shedule a tour Whether the phone is required
            soldFormTitle: '', // Sold Form Title
            soldFormButtonText: '', // Sold form submit button
            soldFormNameFormat: '', // sold form name format 'full'/'separate'
            soldFormPhoneRequired: false, // Does the sold form require a phone call ,
            ...colorBlock,
            calcInfo: {},
            apptTitle: '', //leaveMsg Registration Box Title
            apptSubTitle: '', //leaveMsg Registration box secondary title
            apptSubmitText: '', //leaveMsg submit button copy
            apptQuestionMsg: '',
            bgColor: '',
            moduleColor: ''
        };
        return {
            ...config,
            listingDetail: {},
            extData: null,
            isFromAlert:
                this.pageLocation.search.indexOf('isAlertMail=true') > -1,
            PROVIDED_POSITION_KEY,
        };
    },
    watch: {
        showMakeOffer(value) {
            this.updateShowMakeOffer(value);
        },
        originPriority() {
            this.getAgent();
        },
        showCoAgent(value) {
            this.updateShowCoAgent(value)
            this.getAgent();
        },
        daysOnSite(value) {
            this.updateDaysOnSite(value);
        },
        readMoreExpanded(value) {
            this.updateOpenReadMore(value);
        },
        showVirtualTour(value) {
            this.updateShowVirtualTour(value);
        },
        makeOfferButtonText(value) {
            this.updateMakeOfferButtonText(value);
        },
        makeOfferTitle(value) {
            this.updateMakeOfferTitle(value);
        },
        scheduleNameFormat(value) {
            this.updateScheduleNameFormat(value);
        },
        schedulePhoneRequired(value) {
            this.updateSchedulePhoneRequired(value);
        },
        soldFormTitle(value) {
            this.updateSoldFormTitle(value);
        },
        soldFormButtonText(value) {
            this.updateSoldFormButtonText(value);
        },
        soldFormNameFormat(value) {
            this.updateSoldFormNameFormat(value);
        },
        soldFormPhoneRequired(value) {
            this.updateSoldFormPhoneRequired(value);
        }
    },
    provide() {
        return {
            filling(num) {
                if (num % 1 === 0) {
                    return num; 
                } else {
                    return (+num).toFixed(1); 
                }
            },
            payment: this.payment,
            click3D: this.click3D,
            onFavoriteClick: this.onFavoriteClick,
            openCaculator: this.openCaculator,
            createTime: this.createTime,
            readMore: this.readMore,
            getMediaPopIns: this.createMediaPop,
            getGalleryPopIns: this.createGalleryPop,
            schedulePop: this.schedulePop,
            styleTheme: this.styleTheme,
            colorMap: this.colorMap,
            originTheme: this.originTheme,
            showSoldPrice: this.showSoldPrice
        };
    },
    async created() {
        this.listingDetail = this.listingDetail || {};
        this.updatePayment(this.payment);
        this.updateShowMakeOffer(this.showMakeOffer);
        this.updateDaysOnSite(this.daysOnSite);
        this.upTriggerReadMore(this.triggerReadMore);
        this.updateOpenReadMore(this.readMoreExpanded || this.platform.isBot);
        this.updateHasFavor(this.listingDetail.collectStatus);
        this.updateShowVirtualTour(this.showVirtualTour);
        this.updateMakeOfferButtonText(this.makeOfferButtonText);
        this.updateMakeOfferTitle(this.makeOfferTitle);
        this.updateScheduleNameFormat(this.scheduleNameFormat);
        this.updateSchedulePhoneRequired(this.schedulePhoneRequired);
        this.updateSoldFormTitle(this.soldFormTitle);
        this.updateSoldFormButtonText(this.soldFormButtonText);
        this.updateSoldFormNameFormat(this.soldFormNameFormat);
        this.updateSoldFormPhoneRequired(this.soldFormPhoneRequired);
        this.updateTheme(this.theme);
        this.getShare();
        this.onLngNsLoaded('md-detail-info').then(() => {
            this.getInfoFlag();
        });

        this.$EventBus.$on('schedulePop', this.schedulePop);
    },
    beforeMount() {
        !this.wordPressSSR && this.getPrevAndNext();
        !this.hasSave && this.getUpData();
        this.mlsListTrac();
        this.getMortgageToCalcPerMonth();
    },
    computed: {
        ...rootMapState(usePageStore, {
            page: store => store.page || {},
            currencySymbol: store => store.currency.symbol,
            currencyAbbr: store => store.currency.abbr,
            company: store => store.companyInfo,
            siteId: 'siteId'
        }),
        ...rootMapState(useUserStore, {
            user: store => store.user,
            hasLoggedIn: 'hasLoggedIn',
            userEmailVerified: 'userEmailVerified'
        }),
        ...mapState({
            shares: 'shares',
            agentInfo: 'agentInfo',
            hasFavor: 'hasFavor',
            openReadMore: 'openReadMore'
        }),
        seoSchema({ page }) {
            return getListingDetailSchemaInfo(this.info, {
                country: page.country,
                location: this.pageLocation,
                currencyAbbr: this.currencyAbbr,
                agentCreator: page.agentCreator
            });
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        house({ page }) {
            return page.house || {};
        },
        wordPressSSR({ page }) {
            return page.wordPressSSR;
        },

        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        },
        info() {
            return this.listingDetail.info || {};
        },
        isSold() {
            return this.info.listingStatus === 'Sold';
        },
        /** mlsOrg.listingProviderDirection
            * 1: above - show above the price
            * 2: under - show below the copy right part
            * 3: top - show right below the image 
        */
        positionProvided() {
            let mlsOrg = this.info?.mlsOrg;
            if (!mlsOrg || !mlsOrg.listingProviderDirection) {
                return 0 
            }
            return mlsOrg.listingProviderDirection;
        },
        isShowMask() {
            // soldProtected like "Sold,Active,Pending"
            let soldProtected = this.info.mlsOrg?.soldProtected || '';
            let flag = soldProtected.includes(this.info.listingStatus);
            let isVerified = this.userEmailVerified;
            return flag && !isVerified && this.pageLocation.query.vow !== '0';
        },
        showSoldPrice() {
            return getShowSoldPrice({ data: this.info, globalData: this.page })
        },
        currentColorStyle() {
            let ret = {
                ...(this.colorStyle || {}),
                ...calcColorRootVar.call(this, {
                    colors: ['--g-primary-color_50']
                })
            }
            if (this.moduleColor) {
                ret['--module-color'] = this.moduleColor
            }
            return ret
        },
    },
    mounted() {
        //  have protected Anchors are not applied when
        if (this.info && !this.isSold && !this.isShowMask) {
            this.applyAnchor();
        }
        // widget
        let fav = +this.pageLocation.query.fav;
        if ([1, 2].includes(fav)) {
            this.updateHasFavor(fav === 2);
            this.onFavoriteClick();
        }

        this.$EventBus.$emit('siteTrack', {
            listingId: this.listingDetail?.info?.id,
            trackType: 'views_specific_home',
            listingUrl: this.info?.detailUrl ?? this.info?.detailLink,
            address: this.info?.address,
            listingType: 1 // 1 - active listing, 0 - sold listing
        });
        if (this.hasLoggedIn) {
            this.$EventBus.$emit('siteTrack', {
                listingId: this.listingDetail?.info?.id,
                trackType: 'view_five_properties',
                listingType: 1 // 1 - active listing, 0 - sold listing
            });
        }
        this.getMakeAnOfferData();
        this.updateShowCoAgent(this.showCoAgent);
    },
    destroy() {
        this.$EventBus.$off('schedulePop', this.schedulePop);
    },
    methods: {
        ...rootMapActions(usePageStore, {
            getAgentInfo: 'getAgentInfo'
        }),
        ...mapActions({
            updateShowMakeOffer: 'updateShowMakeOffer',
            updateDaysOnSite: 'updateDaysOnSite',
            updateOpenReadMore: 'updateOpenReadMore',
            updateShowVirtualTour: 'updateShowVirtualTour',
            updateMakeOfferButtonText: 'updateMakeOfferButtonText',
            updateMakeOfferTitle: 'updateMakeOfferTitle',
            updateScheduleNameFormat: 'updateScheduleNameFormat',
            updateSchedulePhoneRequired: 'updateSchedulePhoneRequired',
            updateSoldFormTitle: 'updateSoldFormTitle',
            updateSoldFormButtonText: 'updateSoldFormButtonText',
            updateSoldFormNameFormat: 'updateSoldFormNameFormat',
            updateSoldFormPhoneRequired: 'updateSoldFormPhoneRequired',
            updatePayment: 'updatePayment',
            upTriggerReadMore: 'upTriggerReadMore',
            updateHasFavor: 'updateHasFavor',
            updatePerMonth: 'updatePerMonth',
            updateShare: 'updateShare',
            updatePrevAndNext: 'updatePrevAndNext',
            toggleHasFavor: 'toggleHasFavor',
            toggleOpenReadMore: 'toggleOpenReadMore',
            updateInfoFlag: 'updateInfoFlag',
            updateTheme: 'updateTheme',
            updateScheduleTour: 'updateScheduleTour',
            updateShowCoAgent: 'updateShowCoAgent',
            updateListingDetail: 'updateListingDetail'
        }),
        async schedulePop(showPop = true) {
            this.updateScheduleTour({ success: '' });
            if (!showPop) {
                return; 
            }
            const RequestTourPop = await import(
                /* webpackChunkName: "schedule-pop" */ './schedule-pop.vue'
            );
            popMgr.create(RequestTourPop.default, {
                _storeName: this._storeName,
                styleTheme: this.theme,
                isMobileSize: this.isMobileSize,
                schedulePop: this.schedulePop,
                apptTitle: this.apptTitle,
                apptSubTitle: this.apptSubTitle,
                apptSubmitText: this.apptSubmitText,
                apptQuestionMsg: this.apptQuestionMsg,
                additionalTitle: this.additionalTitle,
                extData: this.extData,
                showMakeOffer: this.showMakeOffer
            });
        },
        getMortgageToCalcPerMonth() {
            this.axiosIns
                .get('/api-site/mortgage/getMortgage', {
                    params: {
                        mortgageType: 'detail-mortgage',
                        id: this.info.id
                    }
                })
                .then(res => {
                    let data = res.data;
                    if (data.propertyTaxRate != null) {
                        this.payment.propertyTaxRate = data.propertyTaxRate; 
                    }
                    if (data.hoaFee != null) {
                        this.payment.hoaFee = data.hoaFee; 
                    }
                    if (data.chimeMaintenanceFee != null) {
                        this.payment.chimeMaintenanceFee =
                            data.chimeMaintenanceFee; 
                    }
                    this.calcuPerMonth();
                });
        },
        isScheduleAnchor() {
            let anchorName = 'schedule';
            return this.pageLocation.hash.indexOf(`#${anchorName}`) !== -1;
        },
        applyAnchor() {
            this.isScheduleAnchor() && this.toSchedule();
        },
        async toSchedule() {
            // pc scroll to schedule place ，mobile Login first and then pop up
            if (this.isMobileSize) {
                if (
                    this.$refs.mobileBottomMenu &&
                    this.$refs.mobileBottomMenu.showTour
                ) {
                    let isLogin = await window.getStore('user').getUser({
                        checkOtherIframe: true,
                        fromGlobal: true
                    });

                    let needPopUp = onAutoPopup(
                        window.siteAppVm,
                        (this.page.registration &&
                            this.page.registration.autopopup) ||
                            {}
                    );
                    if (
                        (!isLogin && this.pageLocation.query.isPopup == 1) ||
                        (!isLogin && needPopUp)
                    ) {
                        // not logged in   if global isPopup for 1 || cms with configuration pop， Add to schedule call back ， Will be called after global registration and login ，
                        this.page.scheduleAnchor.loginCallback =
                            this.$refs.mobileBottomMenu.schedulePop.bind(this);
                    } else {
                        this.$refs.mobileBottomMenu.schedulePop();
                    }
                }
            } else {
                let detailInfo = this.$refs.detailInfo.$el;
                let fixedBanner = document.querySelector('.fixed-banner');
                fixedBanner = (fixedBanner && fixedBanner.offsetHeight) || 0;
                let top = detailInfo.getBoundingClientRect().top || 0;
                window.scrollTo({
                    top: top - fixedBanner + document.documentElement.scrollTop,
                    left: 0,
                    behavior: 'smooth'
                });
            }
        },
        calcuPerMonth() {
            let info = this.info;

            this.payment.total = this.isSold ? info.soldPrice : info.price;
            this.payment.downPaymentValue = (
                (this.payment.total * this.payment.downPaymentRatio) /
                100
            ).toFixed(3);
            this.payment.propertyTax = (
                (this.payment.total * this.payment.propertyTaxRate) /
                100
            ).toFixed(3);

            let result = formula(Object.assign({}, this.payment));
            let pricePerMonth = Object.values(result).reduce((prev, cur) => {
                return prev + +cur;
            }, 0);
            pricePerMonth = Math.round(pricePerMonth);
            this.updatePerMonth(pricePerMonth);
        },
        getAgent: mapAsyncData(getAgent),
        mlsListTrac() {
            if (this.info.mlsOrg && this.info.mlsOrg.listTrac === true) {
                util.addScript(
                    '//code.listtrac.com/monitor.ashx?acct=x_100692&nonjq=1',
                    true
                ).then(() => {
                    if (window._LT) {
                        window._LT._trackEvent(
                            window._eventType['view'],
                            this.info.mlsListingId,
                            this.info.zipCode,
                            this.info.agentLicense
                        );
                    }
                });
            }
        },
        getShare() {
            let shares = {
                facebookHref: '',
                twitterHref: '',
                linkedinHref: '',
                gmailHref: ''
            };
            let info = this.listingDetail?.info || {};
            const origin = this.pageLocation.origin;
            //  fourth set url for detailLink other for detailUrl
            const href = `${origin}/${info.detailUrl || info.detailLink}`;
            shares.facebookHref = this.wordPressSSR
                ? `https://www.facebook.com/share.php?u=${href}`
                : this.listingDetail.facebookHref;
            shares.twitterHref = this.wordPressSSR
                ? `https://twitter.com/share?text=${this.$t(
                    'md-detail-info.instantlyView',
                    { link: href }
                )}`
                : this.listingDetail.twitterHref;
            shares.linkedinHref = this.wordPressSSR
                ? `https://www.linkedin.com/shareArticle?url=${href}&title=${this.$t(
                    'md-detail-info.hotListingInCity',
                    { city: info.city }
                )}`
                : this.listingDetail.linkedinHref;
            shares.gmailHref = this.wordPressSSR
                ? `mailTo:?subject=${info.address}&body=Hi. ${this.$t(
                    'md-detail-info.takeALookAtThisProperty',
                    { link: href }
                )}`
                : this.listingDetail.gmailHref;

            this.updateShare(shares);
        },
        click3D(url, theme) {
            if (this.isMobileSize) {
                window.open(url);
            } else {
                ThreeDTour.open({ url }, theme);
            }
        },
        getPrevAndNext() {
            let source = this.pageLocation.query.source,
                prevHref = '',
                canPrev = false,
                nextHref = '',
                canNext = false,
                show = false,
                prevImg = '',
                nextImg = '';
            this.updatePrevAndNext({
                prevHref,
                canPrev,
                nextHref,
                canNext,
                show
            });
            if (this.isSold || this.platform.isBot) {
                return;
            }
            if (source) {
                let search = this.pageLocation.search.slice(1);
                this.axiosIns
                    .get(
                        getPreNextUrl.call(
                            this,
                            { listingId: this.info.id, search },
                            this.page
                        )
                    )
                    .then(res => {
                        let { previousListing, nextListing } = res;
                        if (previousListing) {
                            let newSearch = this.pageLocation.search.replace(
                                /(page=(\d+))/,
                                'page=' + res.previousPage
                            );
                            prevHref = previousListing + newSearch;
                            canPrev = true;
                            prevImg = res.prevImg;
                        }
                        if (nextListing) {
                            let newSearch = this.pageLocation.search.replace(
                                /(page=(\d+))/,
                                'page=' + res.nextPage
                            );
                            nextHref = nextListing + newSearch;
                            canNext = true;
                            nextImg = res.nextImg;
                        }
                        if (canPrev || canNext) {
                            show = true;
                        }
                        this.updatePrevAndNext({
                            prevHref,
                            canPrev,
                            nextHref,
                            canNext,
                            show,
                            prevImg,
                            nextImg
                        });
                    });
            }
        },
        onFavoriteClick() {
            if (!this.user) {
                signlog.register({
                    languageTextFn: {
                        registerTitle: _ =>
                            this.$t('md-detail-info.saveHomeToFavorites'),
                        registerSubTitle: _ =>
                            this.$t('md-detail-info.registerToEasilySave')
                    },
                    onregister: () => {
                        this.doFavoriteClick();
                    },
                    onLogin: () => {
                        this.doFavoriteClick();
                    }
                });
            } else {
                this.doFavoriteClick();
            }
        },
        doFavoriteClick() {
            this.$EventBus.$emit('siteTrack', {
                listingId: this.info.id,
                listingDetail: this.pageLocation.href,
                status: this.hasFavor ? 2 : 1,
                trackType: 'favor-click',
                address: this.info?.address,
                listingUrl: this.pageLocation.href,
                listingType: 1 // 1 - active listing, 0 - sold listing
            });

            if (!this.doingFavorite) {
                this.axiosIns
                    .get('/api-site/listingCollect', {
                        params: {
                            listingId: this.info.id,
                            token: this.info.token || '',
                            listingSource: this.info.listingSource || '1',
                            listingDetail: this.pageLocation.href,
                            status: this.hasFavor ? 2 : 1,
                            timestamp: new Date().getTime()
                        }
                    })
                    .then(
                        () => {
                            this.doingFavorite = false;
                            this.toggleHasFavor();
                        },
                        () => {
                            this.doingFavorite = false;
                            this.toggleHasFavor();
                        }
                    );
            }
        },
        openCaculator(theme, open) {
            return new Promise(resolve => {
                if (
                    this.info.nodisclosureDes ||
                    (!this.house.showListingPrice &&
                        !this.showSoldPrice &&
                        this.isSold)
                ) {
                    resolve(null);
                }
                if (!this.user && this.triggerCalculator) {
                    signlog.register({
                        onsuccess: () => {
                            resolve(this.doOpenCaculator(theme, open));
                        },
                        onLogin: () => {
                            resolve(this.doOpenCaculator(theme, open));
                        }
                    });
                } else {
                    resolve(this.doOpenCaculator(theme, open));
                }
            });
        },
        doOpenCaculator(theme, open = true) {
            const options = {
                info: this.calcInfo,
                initPayment: {
                    ...this.payment
                },
                onPermonthChange: money => {
                    this.updatePerMonth(money);
                }
            };
            open && Caculator.open(options, {}, theme);
            return options;
        },
        createTime() {
            if (this.isSold || this.info.daysOnMarket) {
                return ''; 
            }
            if (
                this.info.createTimeLong != null ||
                this.info.chimeFirstInserted != null
            ) {
                let date = parseInt();
                let label = '',
                    ms = '';

                if (this.info.createTimeLong) {
                    date = parseInt(this.info.createTimeLong);
                    label = this.$t('md-detail-info.onMarket');
                    ms = this.$t('md-detail-info.market');
                } else {
                    date = parseInt(this.info.chimeFirstInserted);
                    label = this.$t('md-detail-info.onSite');
                    ms = this.$t('md-detail-info.site');
                    if (this.info.daysOnSite) {
                        return '';
                    }
                }
                if (!isNaN(date)) {
                    var today = new Date(),
                        marketDate = new Date(date);
                    var day = Math.floor(
                        (today - marketDate) / 1000 / 3600 / 24
                    );
                    let dateOffset = 10;
                    if (this.info.daysOnSite) {
                        dateOffset = +this.info.daysOnSite;
                    }
                    if (day >= 0) {
                        let timeago = '';
                        if (day > dateOffset) {
                            timeago = this.$t('md-detail-info.daysOn', {
                                day,
                                ms
                            });
                        } else if (day === 0) {
                            timeago = this.$t('md-detail-info.newOnToday', {
                                ms
                            });
                        } else if (day === 1) {
                            timeago = this.$t('md-detail-info.newOnAgo_one', {
                                day,
                                ms
                            });
                        } else {
                            timeago = this.$t('md-detail-info.newOnAgo_other', {
                                day,
                                ms
                            });
                        }
                        return label + ': ' + timeago;
                    }
                }
            }
            return '';
        },
        readMore(callback) {
            if (
                !this.user &&
                this.pageLocation.query.isPopup !== '0' &&
                this.triggerReadMore &&
                !this.readMoreExpanded
            ) {
                signlog.register({
                    onregister: () => {
                        this.doReadMore(callback);
                    },
                    onLogin: () => {
                        this.doReadMore(callback);
                    }
                });
            } else {
                this.doReadMore(callback);
            }
        },
        doReadMore(callback) {
            this.toggleOpenReadMore();
            callback(this.openReadMore);
        },
        getInfoFlag() {
            let infoFlag = {},
                listingTag,
                exclusiveTag;
            if (
                (listingTag = this.info?.listingTags?.[0]) ||
                this.info?.listingStatus
            ) {
                infoFlag.tag = {
                    className: listingTag?.style?.className || '',
                    value: listingTag?.value || this.info?.listingStatus
                };
            }
            if ((exclusiveTag = this.info?.exclusiveListingTag)) {
                infoFlag.exclusiveTag = {
                    className: exclusiveTag?.style?.className,
                    value: exclusiveTag?.value
                };
            }
            if (['Coming Soon'].includes(this.info?.listingStatus) && this.info?.chimeActivationDateTime) {
                const time = this.$ft.formatDate(
                    new Date(this.info.chimeActivationDateTime),
                    'MM/dd/yyyy'
                );
                infoFlag.onMarketTag = {
                    className: 'coming-soon',
                    value: this.$t('md-detail-info.onMarketTag') + ' ' + time
                };
            }
            this.updateInfoFlag(infoFlag);
        },
        getUpData() {
            this.axiosIns
                .get('/api-site/place-data?fetcher=data&source=detailUpData')
                .then(res => {
                    let detailUpData = res.data || {};
                    if (typeof detailUpData === 'string') {
                        detailUpData = JSON.parse(detailUpData);
                    }
                    if (!isUrls({ names: ['sold-detail', 'listing-detail'], url: this.pageLocation.pathname })) {
                        delete detailUpData.triggerCalculator;
                        delete detailUpData.triggerReadMore;
                    }
                 
                    for (let key in detailUpData) {
                        this[key] = detailUpData[key];
                    }
                });
        },
        sharePop() {
            popMgr.create(SharePop, {
                _storeName: this._storeName,
                shares: this.shares,
                theme: this.theme
            });
        },
        mediaPop() {
            return this.$refs?.mediaPop;
        },
        getMakeAnOfferData() {
            if (
                !this.showMakeOffer ||
                util.inCmsPageEditor ||
                !this.hasLoggedIn ||
                !this.info.id
            ) {
                return;
            }

            this.axiosIns
                .get(
                    `/api-site/listing/last_one?listingId=${
                        this.info.id
                    }&t=${Date.now()}`
                )
                .then(({ data }) => {
                    if (!data) {
                        return; 
                    }
                    this.updateScheduleTour({
                        success: true,
                        offer: {
                            message: data.message,
                            price: data.price
                        }
                    });
                });
        },
        createMediaPop() {
            if (!this.isMobileSize) {
                return; 
            }
            const component = this.theme !== 'layout1' ? MediaPop : MediaPopLayout
            return popMgr.create(component, {
                _storeName: this._storeName,
                listingDetail: this.listingDetail,
                sharePop: this.sharePop,
                schedulePop: this.schedulePop,
                theme: this.theme,
                onFavoriteClick: this.onFavoriteClick,
                sold: this.isSold
            });
        },
        createGalleryPop() {
            if (!this.isMobileSize) {
                const component = this.theme !== 'layout1' ? GalleryPop : GalleryPopLayout
                return popMgr.create(component, {
                    _storeName: this._storeName,
                    listingDetail: this.listingDetail,
                    shares: this.shares,
                    theme: this._baseTheme || this.theme,
                    onFavoriteClick: this.onFavoriteClick,
                    sold: this.isSold,
                    schedulePop: this.schedulePop
                });
            }
        },
        getPlainTextFromHTML(htmlString) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = htmlString;
            return tempDiv.textContent || tempDiv.innerText || "";
        },
        async getOfficeStatus() {
            const res = await getOfficeStatus.call(this,
                [this.page.listingId],
                this.page.isSoldListing,
                this.page?.agentCreator?.agentUser?.id);
            if (!res) {
                return 
            }
            const officeStatus = res[this.page.listingId];
            this.updateListingDetail({
                ...this.listingDetail,
                info: {
                    ...this.listingDetail?.info,
                    isOfficeListed: officeStatus,
                    mlsOrg: {
                        ...this.listingDetail?.info?.mlsOrg,
                        template: getTemplate(this.listingDetail?.info, officeStatus, 'template')
                    }
                }
            })
        },
    }
};
